import React, { useEffect } from "react";
import "../styles/upcomingForums.css";
import { FaArrowRightLong } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { getAllEvents } from '../features/events/eventsSlice';
import { Link, useNavigate } from "react-router-dom"; // ✅ Import useNavigate

const formatDateRange = (start, end) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const startDate = new Date(start).toLocaleDateString('en-US', options);
  const endDate = new Date(end).toLocaleDateString('en-US', options);
  return start === end ? startDate : `${startDate} – ${endDate}`;
};

const UpcomingForums = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ Initialize navigate
  const eventsState = useSelector((state) => state.event.events);

  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);

  const handleEvent = (id) => {
    navigate(`/event/${id}`);  
  };

  return (
    <div className="forums-container">
      <div className="forum-header">
        <div className="forum-header-title">
          <h4 className="calendar-title">CALENDAR</h4>
          <h2 className="forums-title">Upcoming Forums</h2>
        </div>
        <div className="more-events">
          <Link to="/events">
            More Events <FaArrowRightLong />
          </Link>
        </div>
      </div>

      <div className="forum-list">
        {eventsState && eventsState.length > 0 ? (
          eventsState.map((event) => (
            <div className="forum-item" key={event._id}>
              <div className="forum-time">
                {formatDateRange(event.startDate, event.endDate)}
              </div>
              <div className="forum-details">
                <div className="forum-title">{event.title}</div>
                <div className="forum-speaker">
                  {event.speaker} <span>Speaker</span>
                </div>
                <div className="forum-location">
                  {event.city}
                  <br />
                  <span>{event.venue}</span>
                </div>
              </div>
              <div className="forum-arrow-container">
                <div
                  className="forum-arrow"
                  onClick={() => handleEvent(event._id)}
                >
                  <FaArrowRightLong className="forum-icon" />
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="no-forums">No upcoming events.</p>
        )}
      </div>
    </div>
  );
};

export default UpcomingForums;
